import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';


interface FooterLink {
  label: string;
  href: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})

export class FooterComponent {
  footerSections: FooterSection[] = [
    // {
    //   title: 'Investment Portfolios',
    //   links: [
    //     { label: 'Real Estate', href: '#real-estate' },
    //     { label: 'Clean Energy (LNG)', href: '#clean-energy' },
    //     { label: 'Artificial Intelligence', href: '#ai' },
    //     { label: 'Agriculture', href: '#agriculture' }
    //   ]
    // },
    {
      title: 'Global Offices',
      links: [
        { label: 'UAE - Abu Dhabi', href: '#contact' },
        { label: 'UK - London', href: '#contact' },
        { label: 'Luxembourg', href: '#contact' },
        { label: 'Switzerland - Zurich', href: '#contact' }
      ]
    },
    {
      title: 'Resources',
      links: [
        // { label: 'Investment Guide', href: '#investment-guide' },
        { label: 'ROI Calculator', href: '#calculator' },
        // { label: 'Market Insights', href: '#insights' },
        { label: 'Contact Us', href: '#contact' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Disclaimer', href: '/disclaimer' },
        { label: 'Privacy Policy', href: '/privacy-policy' },
        { label: 'Terms of Use', href: '/terms-and-conditions' }
      ]
    }
  ];

  currentYear: number = new Date().getFullYear();

  constructor(private router: Router) {}

  onLinkClick(event: Event, href: string): void {
    // In-page anchors: smooth scroll
    if (href.startsWith('#')) {
      event.preventDefault();
      const elementId = href.substring(1);
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', href);
      }
      return;
    }

    // Internal routes: use Angular Router
    if (href.startsWith('/')) {
      event.preventDefault();
      this.router.navigateByUrl(href);
      return;
    }

    // External links: allow default behavior
  }
}
